<div *ngIf="pledge; else loading">
  <div class="pledge-edit-header mb-20 mct-flex mct-row mct-justify-between mct-items-center"  >
    <div *ngIf="profileAvatarInfo" style="font-size: 18px">
      <wl-profile-type-icon
        [isMember]="profileAvatarInfo.IsMember"
        [isOrg]="profileAvatarInfo.IsOrg"
        [profileId]="pledge.ProfileId"
        [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"
        class="mr-11"
      ></wl-profile-type-icon>
      <strong>{{ profileAvatarInfo.ReportName }}</strong
      >&nbsp; <span style="color: #999">({{ pledge.ProfileId }})</span>&nbsp;
    </div>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-12"   >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button
        class="atlas-btn atlas-btn-primary"
        *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
        [disabled]="!detailsForm.valid || billingSaving"
        (click)="saveClicked()"
      >
        <span *ngIf="!isSaving && !billingSaving">{{ 'common.save' | translate | uppercase }}</span>
        <wl-busy *ngIf="isSaving || billingSaving" [show]="true"></wl-busy>
      </button>
    </div>
  </div>

  <div class="tabs-wrapper">
    <wlx-tabs>
      <wlx-tab [title]="'revenue.pledge.edit.details.title' | translate | titlecase">
        <form #detailsForm="ngForm" (ngSubmit)="save()">
          <wl-pledge-edit-details [pledge]="pledge"></wl-pledge-edit-details>
          <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-12"   >
            <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
              {{ 'common.cancel' | translate | uppercase }}
            </button>
            <button
              *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
              type="submit"
              class="atlas-btn atlas-btn-primary"
              [disabled]="!detailsForm.dirty || !detailsForm.valid || billingSaving"
            >
              <span *ngIf="!isSaving && !billingSaving">{{ 'common.save' | translate | uppercase }}</span>
              <wl-busy *ngIf="isSaving || billingSaving" [show]="true"></wl-busy>
            </button>
          </div>
        </form>
      </wlx-tab>
      <wlx-tab
        [title]="'revenue.pledge.edit.billing.title' | translate | titlecase"
        *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
      >
        <div>
          <wl-pledge-edit-billing-list *ngIf="pledge" [pledge]="pledge" [profileId]="pledge.profileId"></wl-pledge-edit-billing-list>
        </div>
      </wlx-tab>
      <wlx-tab
        [title]="'revenue.pledge.edit.invoices.title' | translate | titlecase"
        *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
      >
        <div class>
          <wl-pledge-edit-invoices *ngIf="pledge" [pledge]="pledge"></wl-pledge-edit-invoices>
        </div>
      </wlx-tab>
    </wlx-tabs>
  </div>
</div>

<ng-template #loading>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy [show]="true" [isLarge]="true"></wl-busy>
  </div>
</ng-template>
